import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from 'theme';
import { ManifestTabKeys } from 'views/manifests/manifest-details/types';
import { InfoTitle, InfoValue, InfoWrapper } from 'views/declarations/common/DeclarationInformation.styles';

const ManifestReference = styled(InfoValue)`
    line-height: normal;
`;

const ManifestLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    color: ${colors.brand6};

    &:hover {
        text-decoration: underline;
    }
`;

const ManifestTitle = styled(InfoTitle)`
    align-self: center;
`;

type Props = {
    reference?: string;
    manifestId?: string;
};

const ArrivalManifestLink = ({ reference, manifestId }: Props) => {
    if (!reference) return null;

    return (
        <InfoWrapper data-testid="arrival-notification-manifest-id">
            <ManifestTitle>Manifest ID: </ManifestTitle>
            {manifestId ? (
                <ManifestLink
                    to={`/manifests/${manifestId}/${ManifestTabKeys.ENS}`}
                    data-testid="arrival-notification-manifest-link"
                >
                    <ManifestReference>{reference}</ManifestReference>
                </ManifestLink>
            ) : (
                <ManifestReference>{reference}</ManifestReference>
            )}
        </InfoWrapper>
    );
};

export default ArrivalManifestLink;
